import Vue from 'vue'
import { sendEvent } from '@doxo/willow-analytics'

/**
 * track directive
 * Track external link or UI clicks and send to Google Analytics
 *
 * @usage
 *
 * <a href="someUrl" v-track:link="{category: 'Cat', action: 'Action', label: 'Some label'}>Trackable Link</a>
 */

const getOptions = (el, binding) => {
  let type = binding.arg || 'link'
  let defaults = {
    value: null,
    delay: false
  }
  let options = Object.assign({}, defaults, binding.value)
  if (!options.category) {
    options.category = type === 'link' ? 'Downloads' : 'UI'
  }
  if (!options.action) {
    if (type === 'link') {
      throw new Error('An action is required for track directive of type "link"')
    } else {
      if (el.id) {
        options.action = `Click ${el.tagName.toLowerCase()}#${el.id}`
      } else {
        throw new Error('Element with a "track" directive must have an ID')
      }
    }
  }
  if (!options.label) {
    options.label = type === 'link' ? document.location.href : el.textContent
  }

  return options
}

const untrack = el => {
  el.removeEventListener('click', el.__trackClick__)
  delete el.__trackClick__
  delete el.__trackOptions__
}

Vue.directive('track', {
  inserted (el, binding) {
    untrack(el)
    if (binding.value === false) return

    el.__trackOptions__ = getOptions(el, binding)
    el.__trackClick__ = function (e) {
      // When applied to a Vuetify v-list-tile, the element is an LI
      // So get the child node's href (DOHA-1412)
      let href = el.href || el.childNodes[0].href

      if (!el.__trackOptions__) return
      const options = { ...el.__trackOptions__ }
      let delay = options.delay
      delete options.delay

      // should we catch this Error case in the getOptions function with the others??
      if (delay && !options.hitCallback) {
        if (!href) {
          throw new Error('Link Element with a "track" directive and "delay" attribute must have an "href"')
        }
        e.preventDefault()
        options.eventCallback = () => {
          window.location = href
        }
      }

      sendEvent(options)
    }
    el.addEventListener('click', el.__trackClick__, true)
  },
  componentUpdated (el, binding) {
    if (binding.value === false) {
      untrack(el)
    } else {
      el.__trackOptions__ = getOptions(el, binding)
    }
  },
  unbind (el) {
    untrack(el)
  }
})



// WEBPACK FOOTER //
// ./frontend/src/directives/analytics.js